module.exports = {"driverJob":{"title":"Job List","navigate":"Navigate","start":"Start","end":"End","startCarMile":"Start Mile","endCarMile":"End Mile","fillDistanceStart":"Fill in form mile start","fillDistanceEnd":"Fill in form mile end","pleaseCheckConfirm":"Please check and confirm before returning the vehicle","checkMiles":"Check both the start and end miles of the car","km":"Km","qDrive":"Drive's Queue","orderItem":"Sort Queue by date time.","preparingDrive":"In Process","totalMile":"Total Mile","totalCost":"Total Cost","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/driverJob.json
// module id = 700
// module chunks = 63